export default __webpack_public_path__ + "svg/CompaniesLogos/logo_honest-strategy.svg?fad3bfff";